import { DELETE_HRBP_RELATION, CREATE_HRBP_RELATION } from './HRBPMutations'
import { ACTIVE_HRBPS_BY_COUNTRY } from './HRBPQueries'
import {
  Country,
  DeleteHrbpRelationMutation,
  DeleteHrbpRelationMutationVariables,
  CreateHrbpRelationMutation,
  CreateHrbpRelationMutationVariables,
} from '../../types'
import { client } from '../..'
import { GraphQLFormattedError } from 'graphql'

export const deleteHRBPRelation = async (
  id: string,
  country: Country,
): Promise<{
  data: DeleteHrbpRelationMutation | null | undefined
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  errors: readonly GraphQLFormattedError<Record<string, any>>[] | undefined
}> => {
  const { data, errors } = await client.mutate<DeleteHrbpRelationMutation, DeleteHrbpRelationMutationVariables>({
    mutation: DELETE_HRBP_RELATION,
    variables: {
      id,
    },
    refetchQueries: [
      {
        query: ACTIVE_HRBPS_BY_COUNTRY,
        variables: {
          country,
        },
      },
    ],
  })
  return { data, errors }
}

export const createHRBPRelation = async (
  employeeId: string,
  companyIds: string[],
  country: Country,
): Promise<{
  data: CreateHrbpRelationMutation | null | undefined
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  errors: readonly GraphQLFormattedError<Record<string, any>>[] | undefined
}> => {
  const { data, errors } = await client.mutate<CreateHrbpRelationMutation, CreateHrbpRelationMutationVariables>({
    mutation: CREATE_HRBP_RELATION,
    variables: {
      employeeId,
      companyIds,
    },
    refetchQueries: [
      {
        query: ACTIVE_HRBPS_BY_COUNTRY,
        variables: {
          country,
        },
      },
    ],
  })
  return { data, errors }
}
